import { FoundationsSwitchType } from '../Types/FoundationsTypes'
import { FoundationsGeneric } from './FoundationsGeneric'
import InformativeTooltip from './Tooltip/InfoTooltip'

export function FoundationsSwitch(props: FoundationsSwitchType) {
    const errorStyle = {
        color: 'red',
        display: 'none',
    }
    return (
        <FoundationsGeneric
            id={props.id + '_container'}
            customStyle={props.customStyle}
            classes={props.classes || ''}
        >
            <div className={props.hidden ? 'hide' : ''}>
                <span className={props.classes || ''}>
                    <input
                        type="checkbox"
                        id={props.id}
                        name={props.name}
                        className="generic-switch"
                        checked={props.isChecked}
                        onChange={props.onChange}
                    />
                    <i className=" helper"></i>
                    {props.label}
                </span>
                {props.toolTipText != undefined && (
                    <span className={'text-right mt-1 tooltip-icons ' + props.tooltipClasses}>
                        <InformativeTooltip
                            content={props.toolTipText}
                            placement="right-end"
                            animation="shift-away-subtle"
                            allowHTML={true}
                            showIcon={true}
                            theme = "default-tooltip"
                        />
                    </span>
                    // FP-10632 Updated the earlier tooltip implementation with the new one (InformativeTooltip)

                )}
                <span className={props.errorClasses || ''}>
                    <label htmlFor={props.id} className="error" style={errorStyle}></label>
                </span>
            </div>
        </FoundationsGeneric>
    )
}
